import classNames from "classnames";
import consts from "shared/consts";
import dropdownStyles from "../edit-task-modal.module.css";
import styles from "./task-color-picker.module.css";

export function TaskColorPicker({ onChange }: { onChange: (color: string) => void }) {
  return (
    <div className={classNames(styles.colorPicker, dropdownStyles.dropdownPopup)}>
      {consts.COLOR_PALETTE.map((color) => (
        <div className={styles.colorCircleCell} key={color} id={color} onClick={() => onChange(color)}>
          <div className={styles.colorCircle} style={{ backgroundColor: color }} />
        </div>
      ))}
    </div>
  );
}
